import Select from 'react-select';
import { useLiveQuery } from "dexie-react-hooks";
import { db, withExtras, withParents, withFormulas } from "../../Utils/Functions/Dexie-Setup";
import { tableConfigs } from "../../Utils/Functions/Table_Configs";
import { useMemo, useCallback } from "react"


const defaultDisplay = ["recordId"];
const defaultFunc = () => (true)

//defaultValues, canCreate, 
const RelationshipInput = ({ tableName, fieldValue, setFieldValue, label, displayFields = defaultDisplay, filter = defaultFunc, disabled, ...rest }) => {

  const keyField = useMemo(() => tableConfigs[tableName].fields.find(field => field.type === "key").label, [tableName]);

  const createOptions = useCallback((records) => {
    // console.log({ records })
    return records?.map(record => ({
      label: displayFields.map((curr) => record[curr]).join(" | "),
      value: record[keyField],
    }))
  }, [displayFields, keyField])

  const options = useLiveQuery(() => db[tableName].filter(filter).toArray(withExtras(tableName, [withParents, withFormulas, () => createOptions])), [tableName, filter])

  const onChange = useCallback((newValue) => setFieldValue(newValue?.value ?? null), [setFieldValue])

  return (
    <>
      <label htmlFor={`${tableName}-${label}`} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
      <Select
        id={`${tableName}-${label}`}
        isClearable
        onChange={onChange}
        options={options}
        value={options?.find(({ value }) => fieldValue === value) ?? null}
        isDisabled={!!disabled}
        {...rest}
      />
    </>
  )
}

export default RelationshipInput
